module.exports = __webpack_public_path__ + "svgs/inactive.4a6c380a.svg";